import { Http } from 'packages/workspace/modules/prelude/http';
import { UseQueryResult, useQuery } from 'react-query';
import type { ResponseFormat } from './../models/global-models';

interface InternalOnCallResponse {
  token: string;
  phone: string;
}
/**
 * type - internal or external
 * @param enabled
 * @param type
 * @returns
 */
const useInternalOnCalls = (enabled: boolean, type: string): UseQueryResult<InternalOnCallResponse> => {
  return useQuery(['int-credentials'], () => Http.Request<ResponseFormat<InternalOnCallResponse>>('GET', `/workspaces/api/v1/internal-oncalls.token?type=${type}`).then((res) => res.data), {
    enabled: enabled,
    staleTime: 0,
    retry: 1,
  });
};
export default useInternalOnCalls;
